var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistoryIconBlue = function SvgHistoryIconBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 7.75V12l3.5 3.5M2.75 4.75v4h4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.25 15.083a9.27 9.27 0 0 0 8.736 6.167c5.117 0 9.264-4.141 9.264-9.25s-4.147-9.25-9.264-9.25A9.27 9.27 0 0 0 3.45 8.403"
  })));
};
export { SvgHistoryIconBlue as ReactComponent };
export default __webpack_public_path__ + "83e9d26f52ba48ac9a24b9f3c547f259.svg";